<div class="back-to-home rounded d-none d-sm-block">
  <a routerLink="/index" class="btn btn-icon btn-primary">
    <i-feather name="home" class="icons"></i-feather>
  </a>
</div>

<!-- Hero Start -->
<section class="bg-auth-home bg-circle-gradiant d-table w-100">
  <div class="bg-overlay bg-overlay-white"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-8">
        <div class="card shadow rounded border-0 mt-4">
          <div class="card-body" *ngIf="form">
            <h4 class="card-title text-center">Signup</h4>
            <upload-profile-image (onUploadFinished)="onUploadFinished($event)"></upload-profile-image>
            <form class="login-form mt-4" [formGroup]="form">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">First name <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i-feather name="user" class="fea icon-sm icons"></i-feather>
                      <input type="text" class="form-control ps-5" formControlName="firstName" placeholder="First Name" name="s" required="">
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Last name <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i-feather name="user-check" class="fea icon-sm icons"></i-feather>
                      <input type="text" class="form-control ps-5" formControlName="lastName"  placeholder="Last Name" name="s" required="">
                    </div>
                  </div>
                </div>
                <!--end col-->

                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Your Email <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                      <input type="email" class="form-control ps-5" formControlName="email"  placeholder="Email" name="email" required="">
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Country</label>
                    <div class="form-icon position-relative">
                      <!-- <i-feather name="key" class="fea icon-sm icons"></i-feather> -->
                      <select formControlName="countryId" (change)="countryChanged()" class="form-select form-control" aria-label="Default select example">
                        <option disabled selected value="0">Select Country</option>
                        <option *ngFor="let country of countries" value="{{country.id}}">{{country.nameEn}}</option>
             
                        </select>                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">City</label>
                    <div class="form-icon position-relative">
                      <!-- <i-feather name="key" class="fea icon-sm icons"></i-feather> -->
                      <select formControlName="cityId"  class="form-select form-control" aria-label="Default select example">
                        <option disabled selected value="0">Select City</option>
                        <option *ngFor="let city of cities" value="{{city.id}}">{{city.nameEn}}</option>
             
                        </select>     
                       </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <label class="form-label">Your Mobile</label>
                  <div class="form-icon position-relative">
                  <div class="input-group mb-2" >
                    <div class="input-group-prepend">
                      <!-- <span class="input-group-text" id="basic-addon1">@</span> -->
                      <i-feather name="phone" class="fea icon-sm icons"></i-feather>
                      <input style="width: 100px;" type="tel" class="input-group-text"  formControlName="CountryCode"   readonly>
                    </div>
                      <input type="tel" class="form-control ps-5" formControlName="phone"  placeholder="Your Mobile" name="email" >
                    </div>
                   </div>
                  <!-- <div class="mb-3">
                    <label class="form-label">Your Mobile</label>
                    <div class="form-icon position-relative">
                      <i-feather name="phone" class="fea icon-sm icons"></i-feather>
                      <input type="tel" class="form-control ps-5" formControlName="phone"  placeholder="Your Mobile" name="email" >
                    </div>
                  </div> -->
                </div>
                <!--end col-->

                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Password <span class="text-danger">*</span></label>
                    <div class="form-icon position-relative">
                      <i-feather name="key" class="fea icon-sm icons"></i-feather>
                      <input type="password" class="form-control ps-5" formControlName="password"  placeholder="Password" required="">
                    </div>
                  </div>
                </div>
              
                <!--end col-->

                <!-- <div class="col-md-12">
                  <div class="mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label" for="flexCheckDefault">I Accept <a routerLink="/auth-signup-three"
                          class="text-primary">Terms And Condition</a></label>
                    </div>
                  </div>
                </div> -->
                <!--end col-->

                <div class="col-md-12">
                  <div class="d-grid">
                    <button class="btn btn-primary" [disabled]="!form.valid" (click)="submit()">Register</button>
                  </div>
                </div>
                <!--end col-->

                <!-- <div class="col-lg-12 mt-4 text-center">
                  <h6>Or Signup With</h6>
                  <div class="row">
                    <div class="col-6 mt-3">
                      <div class="d-grid">
                        <a href="javascript:void(0)" class="btn btn-light"><i class="mdi mdi-facebook text-primary"></i>
                          Facebook</a>
                      </div>
                    </div>

                    <div class="col-6 mt-3">
                      <div class="d-grid">
                        <a href="javascript:void(0)" class="btn btn-light"><i class="mdi mdi-google text-danger"></i>
                          Google</a>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="mx-auto">
                  <p class="mb-0 mt-3"><small class="text-dark me-2">Already have an account ?</small> <a
                      routerLink="/login" class="text-dark fw-bold">Sign in</a></p>
                </div>
              </div>
              <!--end row-->
            </form>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Hero End -->